import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  listConversationsApi,
  getConversationApi,
  createConversationApi,
  sendMessageApi,
  listMessagesApi,
  markConversationReadApi,
  getUnreadConversationsAndMessagesApi,
} from '@nxsys/services/api/message';
import {
  CreateConversationParams,
  ListConversationsParams,
  SendMessageParams,
  ListMessagesParams,
} from '../../message/types';

export const eeListConversations = createAsyncThunk(
  'employeeConversation/listConversations',
  async (params: ListConversationsParams, { rejectWithValue }) => {
    try {
      const response = await listConversationsApi(params);
      return { ...response, isLoadMore: !!params.cursor };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const eeGetConversation = createAsyncThunk(
  'employeeConversation/getConversation',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getConversationApi(id);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const eeCreateConversation = createAsyncThunk(
  'employeeConversation/createConversation',
  async (params: CreateConversationParams, { rejectWithValue }) => {
    try {
      const response = await createConversationApi(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const eeSendMessage = createAsyncThunk(
  'employeeConversation/sendMessage',
  async (params: SendMessageParams, { rejectWithValue }) => {
    try {
      const { conversationId, ...data } = params;
      const response = await sendMessageApi(conversationId, data);
      return { ...response, _uuid: params.uuid };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const eeLoadMessages = createAsyncThunk(
  'employeeConversation/loadMessages',
  async (params: ListMessagesParams, { rejectWithValue }) => {
    try {
      const { conversationId, ...queryParams } = params;
      const response = await listMessagesApi(conversationId, queryParams);
      return { ...response, isLoadMore: !!params.cursor };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const eeMarkConversationRead = createAsyncThunk(
  'employeeConversation/markConversationRead',
  async (
    { id, userId, agencyId }: { id: number; userId: string; agencyId?: string },
    { rejectWithValue },
  ) => {
    try {
      await markConversationReadApi(id);
      return { id, userId, agencyId };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const eeFetchUnreadCount = createAsyncThunk(
  'employeeConversation/fetchUnreadCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUnreadConversationsAndMessagesApi();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
